import WrapperService from "@/modules/core/services/wrapper-service";
const API_URL = process.env.VUE_APP_ROOT_API + "/api/v1/import"

const serviceName = "Import-Service: ";

export default class ImportService {

  static importDisplayData(successF, errorF) {
    WrapperService.post(API_URL + "/view-app/display", null, serviceName, successF, errorF);
  }

  static importExcel(file, allowOverride, successF, errorF) {
    let formData = new FormData();
    formData.append("excel", file, file.name);
    WrapperService.postWithErrorCause(API_URL + "/excel/facilities/" + !!allowOverride, formData, serviceName, successF, errorF);
  }

    static importSubCustomerExcel(file, allowOverride, successF, errorF) {
      let formData = new FormData();
      formData.append("excel", file, file.name);
      WrapperService.postWithErrorCause(API_URL + "/excel/sub-customers/" + !!allowOverride, formData, serviceName, successF, errorF);
    }
}
